import { AppHelper } from "../appHelper";
import { CommonApp, CommonAppProps, Entity } from "../core/components/commonApp";
import React from "react";
export class ServiceReportCompletion extends React.Component<ServiceReportCompletionAppProps, any> {
    common = new AppHelper();
    projNr: string = null;

    constructor(props: ServiceReportCompletionAppProps) {
        super(props)
        this.common.init(this);
        this.projNr = props.projNr;
    }


    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = (closeAfterSave) => {
        if (this.common.validate()) {
            this.props.entity.Changed = true; // Flag setzen, dass record geändert wurde
            this.props.onSave(this.props.entity);
            this.common.handlePostSave(true, false);
        }
    }

    close = () => {
        this.common.handlePostSave(true, true);
    }

    componentDidMount() {
        if (this.props.afterMount) {
            this.props.afterMount(this);
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};

export interface ServiceReportCompletionAppProps extends CommonAppProps {
    entity: ServiceReportCompletionEntity;
    projNr: string;
    onSave: (entity) => void;
    afterMount?: (instance: any/*Innosoft.App.ServiceReport.ServiceReportCompletion*/) => void;
}

interface ServiceReportCompletionEntity extends Entity {
    Changed: boolean;
}